module.exports = __webpack_public_path__ + "3fcd8d76c7b59aef1ef7980ed3f49715.svg";